import { useState, useCallback } from "react";

const usePagination = (initialPage = 1) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);

  const nextPage = useCallback(() => {
    setCurrentPage((p) => Math.min(p + 1, totalPages));
  }, [totalPages]);

  const prevPage = useCallback(() => {
    setCurrentPage((p) => Math.max(p - 1, 1));
  }, []);

  const setFromResponse = useCallback((pagination) => {
    if (pagination?.total_pages) setTotalPages(pagination.total_pages);
  }, []);

  return { currentPage, totalPages, setCurrentPage, setTotalPages, nextPage, prevPage, setFromResponse };
};

export default usePagination;
